import React, { useEffect } from 'react'

import aboutImg from '../../img/bbb.jpg';
import why from '../../img/why.jpg';

import parteners from '../../img/parteners .jpeg';
import Aos from 'aos'
import 'aos/dist/aos.css'
import { Link } from 'react-router-dom';

export default function Home() {

  useEffect(() => {
    Aos.init({
      duration: 800,
      easing: 'ease-in-out-cubic',
      once: false,
      mirror: true,
      offset: 50
    });
  }, []);





  return <>

{/* Video Hero Section */}
<div className="video-hero-section">
  {/* Background Video */}
  <video 
    autoPlay 
    muted
    loop 
    playsInline
    preload="auto"
    className="hero-video w-100 h-100"
    onError={(e) => console.error('Video failed to load:', e)}
  >
    <source src="/videos/video.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  
  {/* Dark Overlay */}
  <div className="video-overlay"></div>
  
  {/* Content */}
</div>

    {/* About Start */}
    <div className="container-fluid overflow-hidden about py-5">
      <div className="container-fluid py-5">
        <div className="row g-5">
          {/* Left Column - Content */}
          <div className="col-xl-6" data-aos="fade-right" data-aos-delay="200">
            <div className="about-item">
              <div className="pb-5">
                <h1 className="display-5 text-capitalize"> <span className="text-primary">About Us </span> </h1>
                <p className="mb-0 text-light  ">
                  Outlook Digital Solutions is a leading provider
                  of innovative technology solutions,
                  specializing in interactive panels, sound
                  systems, and computers. Our mission is to
                  enhance user experiences through cuttingedge digital solutions tailored to meet the
                  needs of our clients.            </p>
              </div>

              {/* Vision & Mission prodds */}
              <div className="row g-4">
                <div className="col-6 col-sm-6" data-aos="fade-up" data-aos-delay="300">
                  <div className="about-item-inner border p-4">
                    <div className="about-icon mb-4">
                     <i className="fa fa-eye me-1"></i>
                    </div>
                    <h5 className="mb-3 ">Our Vision</h5>
                    <p className="mb-0">To be a trusted partner in digital
                      transformation, empowering businesses and
                      educational institutions with innovative
                      technology solutions that enhance productivity
                      and collaboration.</p>
                  </div>
                </div>
                <div className="col-6 col-sm-6" data-aos="fade-up" data-aos-delay="400">
                  <div className="about-item-inner border p-4">
                    <div className="about-icon mb-4">
                     <i className="fa fa-fire me-1"></i>
                    </div>
                    <h5 className="mb-3">Our Mission</h5>
                    <p className="mb-0">To deliver high-quality, reliable, and user-friendly
                      technology products that meet the evolving needs
                      of our customers..</p>
                  </div>
                </div>
              </div>


              {/* Experience & Features */}
              <div className="row g-4">
                <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
                  <div className="text-center rounded p-4">
                    <h1 className="display-6 text-white">10</h1>
                    <h5 className="text-light mb-0">Years Of Experience</h5>
                  </div>
                </div>
                <div className="col-lg-6" data-aos="fade-up" data-aos-delay="400">
                  <div className="rounded">
                    <p className="mb-2"><i className="fa fa-check-circle text-primary me-1"></i> Accountability</p>
                    <p className="mb-2"><i className="fa fa-check-circle text-primary me-1"></i> Excellence</p>
                    <p className="mb-2"><i className="fa fa-check-circle text-primary me-1"></i> Integrity</p>
                    <p className="mb-0"><i className="fa fa-check-circle text-primary me-1"></i> After-sales service
                    </p>
                  </div>
                </div>

                {/* CTA & Founder */}
                <div className="col-lg-5 d-flex flex-column align-items-center justify-content-center" data-aos="fade-up" data-aos-delay="500">
                  <Link to="/about" className="btn btn-primary rounded py-3 px-5">More About Us</Link>
                </div>

              </div>
            </div>
          </div>

          {/* Right Column - Images */}
          <div className="col-xl-6 ps-5" data-aos="fade-left" data-aos-delay="200">
  <div className="about-img d-flex flex-column align-items-center justify-content-center">
    <div className="img-1 text-center mb-4">
      <img
        src={aboutImg}
        className="img-fluid rounded w-75 mx-auto d-block"
        alt="About us"
      />
    </div>
  
  </div>
</div>
        </div>
      </div>
    </div>
    {/* About End */}
        {/* servces start */}
  <div className="container-fluid service py-5">
  <div className="container-fluid py-5">
    <div className="text-center mx-auto pb-5" style={{ maxWidth: '800px' }}>
      <h1 className="display-5 text-capitalize mb-3">Our <span className="text-primary">Services</span></h1>
      <p className="mb-0 lead">
        Transforming spaces with cutting-edge technology and innovative digital solutions
      </p>
    </div>
    
    <div className="row g-4">
      {/* INTERACTIVE PANELS */}
      <div className="col-md-6 ">
        <div className="service-item h-100 p-4 d-flex flex-column shadow-lg rounded-3 border-0">
          <div className="service-icon mb-4 text-center text-primary">
            <i className="fas fa-thumbs-up fa-2x text-dark"></i>
          </div>
          <h4 className=" text-center flex-grow-1 fw-bold">INTERACTIVE SCREENS</h4>
           <div className="video-showcase mb-4">
            <div className="row g-3">
              <div className="col-md-6">
                <div className="video-container position-relative rounded-3 overflow-hidden shadow-sm">
                  <video 
                    className="w-100" 
                    style={{ height: '200px', objectFit: 'cover' }}
                    autoPlay 
                    muted 
                    loop
                    playsInline
                  >
                    <source src="/videos/stripe.MP4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                 
                </div>
              </div>
              <div className="col-md-6">
                <div className="video-container position-relative rounded-3 overflow-hidden shadow-sm">
                  <video 
                    className="w-100" 
                    style={{ height: '200px', objectFit: 'cover' }}
                    autoPlay 
                    muted 
                    loop
                    playsInline
                  >
                    <source src="/videos/disc.MP4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                
                </div>
              </div>
            </div>
          </div>
          <div className="service-features mb-3">
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>High-resolution display with vivid clarity</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Smooth and responsive touch performance</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>First interactive panel with built-in AI capabilities</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Reliable operation with expert after-sales service</span>
            </div>
          </div>
          <p className="mb-3">
            <strong>STRIVE interactive panels</strong> are designed to elevate communication and collaboration 
            in classrooms and meeting spaces. With crystal-clear touch displays, smooth performance, 
            and professional local support, they deliver an effortless and inspiring digital experience.
          </p>
          <p className="mb-3">
            They are used in modern classrooms or meeting rooms to encourage interaction and creativity.
          </p>
        </div>
      </div>
    {/* DESIGN AND INSTALLATION OF INDOOR AND OUTDOOR LED SCREENS */}
      <div className="col-md-6 ">
        <div className="service-item h-100 p-4 d-flex flex-column shadow-lg rounded-3 border-0">
          <div className="service-icon mb-4 text-center text-primary">
            <i className="fas fa-tv fa-2x text-dark"></i>
          </div>
          <h4 className="mb-3 text-center flex-grow-1 fw-bold">DESIGN AND INSTALLATION OF INDOOR AND OUTDOOR LED SCREENS</h4>
             <div className="video-showcase mb-5">
            <div className="row ">
        
             <div className="col-md-6">
                <div className="video-container position-relative rounded-3 overflow-hidden shadow-sm">
                  <video 
                    className="w-100" 
                    style={{ height: '200px', objectFit: 'cover' }}
                    autoPlay 
                    muted 
                    loop
                    playsInline
                  >
                    <source src="/videos/led.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                 
                </div>
              </div>
             <div className="col-md-6">
                <div className="video-container position-relative rounded-3 overflow-hidden shadow-sm">
                  <video 
                    className="w-100" 
                    style={{ height: '200px', objectFit: 'cover' }}
                    autoPlay 
                    muted 
                    loop
                    playsInline
                  >
                    <source src="/videos/ledscreen vid.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                 
                </div>
              </div>
            </div>
          </div>
        
          
          <p className="mb-3">
            Our LED screens are designed to create a stunning visual impact anytime, anywhere. 
            Whether for advertising, events, or professional presentations, our LED display solutions 
            combine cutting-edge technology with durability and clarity.
          </p>
          <p className="mb-3">
            From retail spaces and events to corporate lobbies and public venues, we deliver 
            exceptional visual experiences that captivate your audience.
          </p>
        </div>
      </div>
 
  

      {/* MUSICAL INSTRUMENTS &  AUDIO SYSTEMS */}
      <div className="col-md-6 ">
        <div className="service-item h-100 p-4 d-flex flex-column shadow-lg rounded-3 border-0">
          <div className="service-icon mb-4 text-center text-primary">
            <i className="fas fa-music fa-2x text-dark"></i>
          </div>
          <h4 className="mb-3 text-center flex-grow-1 fw-bold">MUSICAL INSTRUMENTS &  AUDIO SYSTEMS</h4>
   <div className="row">
    <div className="col-md-6">
             <div className="service-features mb-3">
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Exceptional sound quality and durability</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Professional equipment for schools and studios</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Perfect for live performances</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Easy to use and maintain</span>
            </div>
          </div>
    </div>
    <div className="col-md-6">
         <div className="service-features mb-3">
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>High Brightness & Visibility for any environment</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Modular Design with flexible sizing options</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Energy Efficient & Durable construction</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Seamless Installation & Maintenance</span>
            </div>
          </div>
    </div>
   </div>
          <p className="mb-3">
            Our range of professional musical instruments and stage equipment is designed to deliver 
            exceptional sound quality, durability, and ease of use. Perfect for schools, studios, and 
            live performances, our products help musicians and performers bring their creativity to life.
          </p>
        </div>
      </div>

      {/* MOBILE APPLICATIONS & SMART DIGITAL SYSTEMS */}

 <div className="col-md-6  ">
        <div className="service-item h-100 p-4 d-flex flex-column shadow-lg rounded-3 border-0">
          <div className="service-icon mb-4 text-center text-primary">
            <i className="fas fa-mobile-alt fa-2x text-dark"></i>
          </div>
          <h4 className="mb-3 text-center flex-grow-1 fw-bold">MOBILE APPLICATIONS & SMART DIGITAL SYSTEMS</h4>
          <div className="service-features mb-3">
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Custom mobile apps for schools and businesses</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Smart systems and dashboards built on demand</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Seamless integration with interactive panels</span>
            </div>
            <div className="feature-item d-flex align-items-center mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              <span>Tailored to your specific business goals</span>
            </div>
          </div>
          <p className="mb-3">
            We design and develop custom-made digital systems and mobile applications tailored to your 
            specific needs and business goals. Our solutions simplify management, enhance communication, 
            and support digital transformation for schools and companies.
          </p>
          <p className="mb-3 fst-italic text-primary">
            DIGITAL SOLUTIONS DESIGNED JUST FOR YOU
          </p>
        </div>
      </div>
      </div>
       
    </div>
    </div>


    {/* servces end */}
    {/* company fields */}
   {/* <div className="image-gallery-container">
      <div className="gallery-header ">
        <h2 
          className="gallery-title"
          data-aos="fade-down"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
Company fields        </h2>
    
      </div>
      
      <div className="masonry-grid">
        {images.map((image, index) => (
          <div 
            key={index} 
            className={`masonry-item masonry-size-${(index % 5) + 1}`}
            data-aos={getAosAnimation(index)}
            data-aos-duration={getAosDuration(index)}
            data-aos-delay={getAosDelay(index)}
            data-aos-easing="ease-in-out-cubic"
            data-aos-mirror="true"
            data-aos-once="false"
          >
            <div className="image-card">
              <img 
                src={image} 
                alt={`Gallery image ${index + 1}`}
                className="gallery-image"
                loading="lazy"
              />
           
            </div>
          </div>
        ))}
      </div>
      
 
    </div> */}
        {/* company fields */}

    {/* Why Choose Us Section */}
    <div className="container-fluid py-5 chose ">
      <div className="container-fluid py-5">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="mb-4">
              <h1 className="display-5 text-capitalize mb-4">
                <span className="text-primary">Why Choose Us?</span> 
              </h1>
            </div>
            <div className="row g-4">
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div className=" p-4 rounded shadow">
                  <h5 className="mb-3">Expertise</h5>
                  <p className="mb-0">
                    A team of experienced professionals dedicated to providing top-notch solutions.
                  </p>
                </div>
              </div>
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div className=" p-4 rounded shadow">
                  <h5 className="mb-3">Customer-Centric Approach</h5>
                  <p className="mb-0">
                    We prioritize our clients' needs and work closely to deliver customized solutions.
                  </p>
                </div>
              </div>
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="300">
                <div className=" p-4 rounded shadow">
                  <h5 className="mb-3">Innovation</h5>
                  <p className="mb-0">
                    Constantly exploring the latest technologies to provide cutting-edge products.
                  </p>
                </div>
              </div>
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="400">
                <div className=" p-4 rounded shadow">
                  <h5 className="mb-3">Quality Assurance</h5>
                  <p className="mb-0">
                    Rigorous testing and quality control measures to ensure reliable performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left">
            <div className="rounded overflow-hidden">
              <img
                src={why} // You might want to use a different image here
                className="img-fluid rounded"
                alt="Why Choose Us"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
        {/* Why Choose Us Section */}



    {/* CORE VALUES Start */}

    {/* Features End */}
      {/* banner 1 Start */}

      {/* banner 1  End */}

      {/* news Start */}
  
      {/* news End */}
{/* 
      {/* Banner 2 Start */}
   {/* <div className="container-fluid banner pb-5 wow zoomInDown" data-wow-delay="0.1s">
  <div className="container-fluid pb-5">
    <div className="banner-item rounded position-relative">
      <img 
        src={banner1} 
        className="img-fluid rounded w-100" 
        alt="Digital Transformation Solutions" 
        style={{height: "100", objectFit: "cover"}}
      />
      <div className="banner-content position-absolute top-50 start-50 translate-middle text-center">
        <h2 className="text-primary">Transform Your Space</h2>
        <h1 className="text-white">Ready for Digital Innovation?</h1>
        <p className="text-white">Let's discuss how our technology solutions can enhance your business or educational environment.</p>
        <div className="banner-btn">
          <Link to="/contact" className="btn btn-secondary rounded-pill py-3 px-4 px-md-5 me-2">Get Free Consultation</Link>
        </div>
      </div>
    </div>
  </div>
</div>  */}
      {/* Banner 2 End */}
      {/* products start */}

      {/* products start */}


    {/* fact start */}

    {/* <div className="container-fluid counter  py-5">
      <div className="container-fluid py-5">
        <div className="row g-5">
          <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <i className="fas fa-thumbs-up fa-2x"></i>
              </div>
              <div className="counter-counting my-3">
                <span className="text-white fs-2 fw-bold" data-toggle="counter-up">829</span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Happy Clients</h4>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <i className="fas fa-car-alt fa-2x"></i>
              </div>
              <div className="counter-counting my-3">
                <span className="text-white fs-2 fw-bold" data-toggle="counter-up">720</span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Customer Reviews
              </h4>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.5s">
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <i className="fas fa-building fa-2x"></i>
              </div>
              <div className="counter-counting my-3">
                <span className="text-white fs-2 fw-bold" data-toggle="counter-up">127</span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">completed deals</h4>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <i className="fas fa-clock fa-2x"></i>
              </div>
              <div className="counter-counting my-3">
                <span className="text-white fs-2 fw-bold" data-toggle="counter-up">200</span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Total projects</h4>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* fact end */}

{/* parteners start  */}

<div className="container parteners" style={{ minHeight: '450px' }}> 
  
  <div className="row align-items-center" style={{ minHeight: '450px' }}>
    <div className="col-md-12">
             <div className="mb-4 text-center ">
              <h1 className="display-5 text-capitalize my-5">
                <span className="text-primary ">OUR PARTENERS</span> 
              </h1>
            </div>
      <div className="w-100 text-center">
        <img src={parteners} alt="" className="img-fluid" style={{ maxHeight: '440px' }} />
      </div>
    </div>
  </div>
</div>

<div className="container-fluid contact py-5">
    <div className="container-fluid py-5">
        {/* Enhanced Header */}
        <div className="text-center mx-auto pb-5" data-aos="fade-up" data-aos-delay="100">
            <h6 className="text-primary text-uppercase fw-bold mb-2">Get In Touch</h6>
            <h1 className="display-4 fw-bold mb-3">Contact <span className="text-primary">Outlook Digital</span></h1>
          
        </div>

        <div className="row g-5">
            {/* First Column - Contact Information */}
            <div className="col-xl-5" data-aos="fade-right" data-aos-delay="200">
                <div className="row g-4">
                    {/* Address */}
                    <div className="col-6 col-sm-6">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-map-marker-alt fa-2x"></i>
                            </div>
                            <div>
                                <h4>Our Address</h4>
                                <p className="mb-0">
                                    July 23 above Al-Tawhid, Al-Nour,<br />
                                    Seventh Floor - Bani Suef
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-clock me-1"></i> Open: Sun-Thu 9AM-5PM
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* Email */}
                    <div className="col-6 col-sm-6" data-aos="fade-right" data-aos-delay="300">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-envelope fa-2x"></i>
                            </div>
                            <div>
                                <h4>Email Us</h4>
                                <p className="mb-0">
                                    <a  className="text-light text-decoration-none">
                                        sales@outlookds.com
                                    </a>
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-reply me-1"></i> Response within 24 hours
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="col-6 col-sm-6" data-aos="fade-right" data-aos-delay="400">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-phone-alt fa-2x"></i>
                            </div>
                            <div>
                                <h4>Call Us</h4>
                                <p className="mb-0">
                                    <a href="tel:01205450008" className="text-light text-decoration-none">
                                        01205450008
                                    </a>
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-headset me-1"></i> Professional support
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* Website */}
                    <div className="col-6 col-sm-6 " data-aos="fade-right" data-aos-delay="500">
                        <div className="contact-add-item p-4 h-100">
                            <div className="contact-icon mb-4">
                                <i className="fas fa-globe fa-2x"></i>
                            </div>
                            <div>
                                <h4>Visit Us</h4>
                                <p className="mb-0">
                                    <a href="https://www.outlookds.com" 
                                       className="text-light text-decoration-none"
                                       target="_blank" 
                                       rel="noopener noreferrer">
                                        www.outlookds.com
                                    </a>
                                </p>
                            </div>
                            <div className="mt-3">
                                <small className="text-primary">
                                    <i className="fas fa-external-link-alt me-1"></i> Explore our services
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Second Column - Contact Form */}
            <div className="col-xl-7" data-aos="fade-left" data-aos-delay="200">
                <div className="contact-form-container h-100">
                    <h4>Send Us a Message</h4>
                    <form>
                        <div className="row g-4">
                            {/* Name & Email */}
                            <div className="col-md-6">
                                <div className="form-floating">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        id="name" 
                                        placeholder="Your Full Name" 
                                        required 
                                    />
                                    <label htmlFor="name">
                                        <i className="fas fa-user me-2"></i>Your Full Name
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-floating">
                                    <input 
                                        type="email" 
                                        className="form-control" 
                                        id="email" 
                                        placeholder="your.email@example.com" 
                                        required 
                                    />
                                    <label htmlFor="email">
                                        <i className="fas fa-envelope me-2"></i>Your Email Address
                                    </label>
                                </div>
                            </div>

                            {/* Phone & Project Type */}
                            <div className="col-md-6">
                                <div className="form-floating">
                                    <input 
                                        type="tel" 
                                        className="form-control" 
                                        id="phone" 
                                        placeholder="+20 123 456 7890" 
                                    />
                                    <label htmlFor="phone">
                                        <i className="fas fa-phone me-2"></i>Your Phone Number
                                    </label>
                                </div>
                            </div>
                   

                    
                            {/* Message */}
                            <div className="col-12">
                                <div className="form-floating">
                                    <textarea 
                                        className="form-control" 
                                        placeholder="Tell us about your project requirements..." 
                                        id="message" 
                                        style={{ height: '150px' }}
                                        required
                                    ></textarea>
                                    <label htmlFor="message">
                                        <i className="fas fa-comment me-2"></i>Your Message
                                    </label>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="col-12 text-center">
                                <button className="btn btn-contact-submit w-100 py-3 text-light" type="">
                                    <i className="fas fa-paper-plane me-2 text-light"></i>Send Message
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Full Width Map */}
            <div className="col-12" data-aos="fade-up" data-aos-delay="300">
                <div className="map-container">
                    <iframe
                        className="w-100"
                        style={{ height: '450px', border: 'none' }}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Outlook Digital Solutions Location"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</div>

  </>

}
